import * as React from "react";
import type { SVGProps } from "react";
const SvgPlaceanorderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="placeanorder_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M810.667 426.667a42.667 42.667 0 1 0 85.333 0V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h256a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v213.334zm-512 128A42.667 42.667 0 0 1 341.333 512h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.666zm0-213.334a42.667 42.667 0 0 1 42.666-42.666h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.667zm311.253 462.72 127.872 122.923c4.053 3.755 8.832 6.656 14.08 8.619 10.325 4.096 21.973 4.096 32.341 0 5.248-1.963 10.027-4.864 14.08-8.619l127.83-122.923a40.363 40.363 0 0 0 12.544-29.098 40.363 40.363 0 0 0-12.544-29.099 43.69 43.69 0 0 0-30.251-12.075c-11.35 0-22.187 4.352-30.25 12.075l-54.955 53.29v-229.12c0-10.837-4.523-21.29-12.502-28.97a43.52 43.52 0 0 0-30.122-11.99 43.52 43.52 0 0 0-30.123 11.99 40.192 40.192 0 0 0-12.501 29.013v229.078l-54.955-53.334a42.795 42.795 0 0 0-30.293-12.074 44.032 44.032 0 0 0-30.251 12.117 39.637 39.637 0 0 0 0 58.197z"
    />
  </svg>
);
export default SvgPlaceanorderIcon;
